import React, { Component } from 'react';
import './phone.css'
import   SideNav from "../sidenav/sidenav"
import  AuthService  from "../api/authentication";




class Payers extends Component {

 
    constructor(props){
      super(props)
     //  this.onDelete = this.onDelete.bind(this);
     //  this.onEdit = this.onEdit.bind(this);
     //   this.editSubmit = this.editSubmit.bind(this)
      this.state = {
        isEdit:false
      }
    }
   
    onDelete=()=>{
      const {onDelete , id} = this.props
      console.log("id", id)
      onDelete(id)
     
    }

    editpeyer=(event)=>{
      event.preventDefault(); 
      console.log(" ------------ sedit", this.phone.value) 
       const data ={
         phone:this.phone.value ,
         id  : this.id.value ,
         date : Date.now()
       }
      this.props.editpeyer(data)
      this.setState({isEdit:false})
    }

  showedit=()=>{
      console.log("-------")
      this.setState({isEdit:true})
  }
  
  close = ()=>{
   console.log("-------")
   this.setState({isEdit:false})
  }
  alertClick=(event)=>{
   event.preventDefault();
   this.setState({ 
       alertDelete:true
    });  
 }
 closeOnDelete=( event)=>{
   event.preventDefault();
   this.setState({ 
       alertDelete:false
    });  
 }
   

    render(){
      if ( this.state.isEdit == false) {
            return(
              this.state.alertDelete?
                  <div className="notification-body-delete">
                    <div className="notification ">
                            <button className="delete" onClick={this.closeOnDelete}></button>
                            <strong>Are you sure to delete this item</strong><br/>
                            <button className="button is-small  is-danger" onClick={this.onDelete}>delete</button>
                    </div>
                    
                </div>
                :
              <li className="table-row">
             
                <div className="col col-1" data-label="Job Id">{this.props.phone}</div>
                  <div className="col col-2" data-label="Customer Name">
                    {
                      this.props.name ? 
                        <p>{this.props.name}</p> 
                        :
                        <p>Not yet registered</p>
                    }
                  
                  
                  </div>
                
                  <p className="payers-body-buttom">
                      <button className="button is-small is-success " onClick={this.showedit}>edit</button>
                      <button className="button is-small  is-danger" onClick={this.alertClick}>delete</button>
                    </p>
                  
                </li>

            )
          }else{
            return (
              <form  onSubmit={this.editpeyer}>
                   <div >
                          <div className="phone-sub-body-form">  
                            <div className="control has-icons-left has-icons-right">
                                        <input className="input" type="text" ref={input => this.phone = input} defaultValue={ this.props.phone}  placeholder="Phone"   required/>  
                                          <span className="icon is-small is-left">
                                          <i className="fas fa-phone"></i>
                                         </span>  
                                </div> 
                              </div>
                         
                            <input className="input" type="hidden" ref={input => this.id = input} defaultValue={ this.props.id} placeholder="More Information"  required/>  
                            <div className="cell-form1">
                               <button className="button is-small is-success button-style" >Save</button>
                               <a className="button is-small is-link " onClick={this.close}>Close</a>
                            </div>
                            <hr/>
                      </div>   
                   
              </form>
            )

      }
       
 



    }






  }


  


export default  Payers;


// WEBPACK FOOTER //
// ./src/component/phone/payees.js